<template>
	<main class="account-plan">
		<section class="ap-header">
			<div class="ap-actions ap-actions--left">
				<button type="button" class="theme_btn_dark" @click="uploadAllPlanAccounts">
					Importar
				</button>
				<a class="download_btn" :href="`${hostname}/xlsx/${templateName}.xlsx`">
					<component :is="'DownloadFile'"></component>
					<span class="ml-1">Descargar Plantilla</span>
				</a>
				<input type="file" ref="fileInput" @change="(e) => uploadFilePlanAccounts(e)" accept=".xlsx,.xls"
					style="display: none" />
			</div>
			<h2 class="ap-title">Plan de Cuentas</h2>
			<div class="ap-actions ap-actions--right">
				<button v-if="has_repeated_plan_account" type="button" class="theme_btn_red"
					@click="makeAccountPlansUnique">
					Hacer único
				</button>
				<button type="button" class="theme_btn_white" @click="downloadAllPlanAccounts">
					Exportar
				</button>
				<button v-if="basic_data && basic_data.needs_account_plan_review" type="button" class="theme_btn_blue"
					@click="approveAccountPlanReview">
					Completado
				</button>
			</div>
		</section>
		<p class="ap-subtitle">Cuentas {{ consolidatedBusinessType }}</p>

		<div class="px-4 mb-2 is-hidden-mobile">
			<div class="columns is-vcentered ap-colheads">
				<div class="column is-1 has-text-right">Nro.</div>
				<div class="column is-2">Nivel 1</div>
				<div class="column is-3">Nivel 2</div>
				<div class="column is-4">Nivel 3 / Cuenta</div>
				<div class="column is-1">Orden</div>
				<div class="column is-1">Operaciones</div>
			</div>
		</div>

		<div v-for="(item, index) in account_plans" :key="item.id" :class="['ap-row', getRowBackground(index)]">
			<div class="columns is-vcentered">
				<div class="column py-2 is-1">
					<p class="ap-cell ap-cell--num has-text-right">{{ index + 1 }}.-</p>
				</div>
				<div class="column py-2 is-2">
					<p class="ap-cell ap-cell--strong">{{ item.level_1 }}</p>
				</div>
				<div class="column py-2 is-3">
					<p class="ap-cell">{{ item.level_2 }}</p>
				</div>
				<div class="column py-2 is-4">
					<p class="ap-cell">{{ item.level_3 }}</p>
				</div>
				<div class="column py-2 is-1">
					<span class="tag is-rounded is-primary">{{ item.order }}</span>
				</div>
				<div class="column py-2 is-1 ap-ops">
					<button type="button" class="ap-icon-btn" @click="initializeEditingPlanAccount(index)">
						<EditPencil />
					</button>
					<button type="button" class="ap-icon-btn" @click="openConfirmRestoreModal('delete', item.id)">
						<Trash />
					</button>
				</div>
			</div>

			<div v-if="indexEditing == index" class="columns is-vcentered">
				<div class="column py-2 is-3">
					<b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
						id="level_1_select" v-model="level1Editing" placeholder="Nivel 1" rules="required"
						@input="onLevel1Change">
						<option v-for="value in level_1_values" :key="value.name" :value="value.name">
							{{ value.name }}
						</option>
					</b-select>
				</div>
				<div class="column py-2 is-3">
					<b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
						id="level_2_select" v-model="level2Editing" placeholder="Nivel 2"
						:key="level_2_values_depending.length" rules="required">
						<option v-for="value in level_2_values_depending" :key="value.id" :value="value.id">
							{{ value.level_2 }}
						</option>
					</b-select>
				</div>
				<div class="column py-2 is-3">
					<b-input size="is-small" expanded class="new_cuenta new_elem_row" placeholder="Cuenta"
						v-model="level3Editing" />
				</div>
				<div class="column py-2 is-3">
					<div class="field has-addons">
						<div class="control is-expanded mr-1">
							<b-input size="is-small" class="new_cuenta new_elem_row" placeholder="Orden"
								v-model="orderEditing" />
						</div>
						<div class="control is-vcentered py-2">
							<button type="button" class="theme_btn_dark ap-inline-action"
								@click="openConfirmRestoreModal('edit', item.id)">
								OK
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="ap-row ap-row--new">
			<div class="columns is-vcentered">
				<div class="column py-2 is-3">
					<b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
						id="level_1_select" v-model="new_level_1_value" placeholder="Nivel 1" rules="required"
						@input="onLevel1Change">
						<option v-for="value in level_1_values" :key="value.name" :value="value.name">
							{{ value.name }}
						</option>
					</b-select>
				</div>
				<div class="column py-2 is-3">
					<b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
						id="level_2_select" v-model="new_level_2_value" placeholder="Nivel 2" rules="required">
						<option v-for="value in level_2_values_depending" :key="value.id" :value="value.id">
							{{ value.level_2 }}
						</option>
					</b-select>
				</div>
				<div class="column py-2 is-3">
					<b-input size="is-small" expanded class="new_cuenta new_elem_row" placeholder="Cuenta"
						v-model="newAccount" />
				</div>
				<div class="column py-2 is-3">
					<div class="field has-addons">
						<div class="control is-expanded mr-1">
							<b-input size="is-small" class="new_cuenta new_elem_row" placeholder="Orden"
								v-model="new_order" />
						</div>
						<div class="control is-vcentered py-2">
							<button type="button" class="theme_btn_blue ap-inline-action" @click="addAccount">
								+
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import {
	approveAccountPlan,
	createAccount,
	deleteAccount,
	editAccount,
	getAccountPlanForCompany,
	makeUniquePlanAccounts,
	upload_all_plan_accounts,
} from "@/api/carteraAnalista";
import ConfirmRestore from "@/components/modals/ConfirmRestore";
import DownloadFile from "@/components/svg/DownloadFile.vue";
import EditPencil from "@/components/svg/EditPencil";
import Trash from "@/components/svg/Trash";
import {
	consoleHandlerError,
	extractErrorMessage,
	notificate,
} from "@/utils/message";

export default {
	name: "CompanyInfoAccountPlan",
	props: {
		basicData: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	},
	components: {
		EditPencil,
		Trash,
		DownloadFile
	},
	mounted() {
		if (this.basic_data && this.basic_data.companyId) {
			this.loadDefaultPlans()
		}
	},
	data() {
		return {
			consolidatedBusinessType: "_",
			basic_data: {},
			account_plans: [],
			new_level_1_value: "",
			new_level_2_value: "",
			level_1_values: [],
			level_2_values: {},
			level_2_values_depending: [],
			newAccount: "",
			new_order: 0,
			level1Editing: "",
			level2Editing: "",
			level3Editing: "",
			orderEditing: "",
			templateName: "",
			has_repeated_plan_account: false,
			indexEditing: -1,
			modalDefault: {
				parent: this,
				width: "25%",
				hasModalCard: true,
				canCancel: ["escape", "outside"],
				customClass: "center-always-modal",
			},
		};
	},
	computed: {
		hostname() {
			const publicPath = window.location.hostname
			const localhost = ["localhost", "0.0.0.0"]
			if (localhost.includes(window.location.hostname)) {
				return `http://${publicPath}`;
			} else {
				return `https://${publicPath}`;
			}
		},
	},
	methods: {
		approveAccountPlanReview() {
			// Visto bueno del analista: baja el banner "En revisión" del cliente.
			approveAccountPlan(this.basic_data.companyId)
				.then(() => {
					this.basic_data.needs_account_plan_review = false;
					notificate("Visto bueno dado al plan de cuentas.");
				})
				.catch((error) => {
					consoleHandlerError({ error });
				});
		},
		getRowBackground(index) {
			let groupIndex = 0;
			for (let i = 0; i <= index; i++) {
				if (
					i > 0 &&
					this.account_plans[i].level_2 !==
					this.account_plans[i - 1].level_2
				) {
					groupIndex++;
				}
			}

			return groupIndex % 2 === 0 ? "bg-group-a" : "bg-group-b";
		},
		initializeEditingPlanAccount(iPlan) {
			this.indexEditing = iPlan;
		},
		onLevel1Change(val) {
			this.level_2_values_depending = this.level_2_values[val]["items"];
		},
		async addAccount() {
			if (
				!this.basic_data.companyId ||
				!this.new_level_2_value ||
				!this.newAccount
			) {
				notificate("Debe llenar los datos.");
				return;
			}
			try {
				const resp = await createAccount(
					this.basic_data.companyId,
					this.new_level_2_value,
					this.newAccount,
					this.new_order,
				);
				notificate(
					resp.data.status || "Cuenta grabada exitosamente.",
					"is-success is-light",
				);
				this.new_level_2_value = "";
				this.newAccount = "";
				this.new_level_1_value = "";
				this.new_order = "";
				await this.loadDefaultPlans();
			} catch (error) {
				// El backend ahora devuelve 400/404/409 con {detail} en los casos
				// de negocio (falta nivel 2, duplicada, datos incompletos).
				notificate(
					extractErrorMessage(error, "No se pudo crear la cuenta."),
					"is-danger is-light",
				);
				consoleHandlerError({ error, silent: true });
			}
		},
		async editPlanAccount(idPlanAccount) {
			if (
				!this.basic_data.companyId ||
				!this.level2Editing ||
				!this.level3Editing ||
				!this.orderEditing
			) {
				notificate("Debe llenar todos los datos.");
				return;
			}
			try {
				const { data } = await editAccount(
					this.basic_data.companyId,
					idPlanAccount,
					this.level2Editing,
					this.level3Editing,
					this.orderEditing,
				);
				if (data["status"] == "Ok") {
					notificate("Cuenta grabada exitosamente.");
				} else {
					notificate(data["status"]);
				}

				this.level1Editing = "";
				this.level2Editing = "";
				this.level3Editing = "";
				this.orderEditing = "";
				this.indexEditing = -1;
				await this.loadDefaultPlans();
			} catch (error) {
				consoleHandlerError({ error, empty: true });
			}
		},
		async deletePlanAccount(idPlanAccount) {
			try {
				await deleteAccount(this.basic_data.companyId, idPlanAccount);
				notificate("Plan de cuenta borrado");
			} catch (err) {
				notificate("Ocurrio un error");
			} finally {
				await this.loadDefaultPlans();
			}
		},
		async loadDefaultPlans() {
			if (this.basic_data && this.basic_data.companyId) {
				const response = await getAccountPlanForCompany(
					this.basic_data.companyId,
				);
				this.level_1_values = response.data["level_1_values"];
				this.level_2_values = response.data["level_2_values"];
				this.account_plans = response.data["account_plans"];
				this.has_repeated_plan_account =
					response.data["has_repeated_plan_account"];
				if (!this.basic_data.classify_by_sales) {
					this.account_plans = this.account_plans.filter(
						(elem) => elem.level_1 != "Ventas",
					);
					this.level_1_values = this.level_1_values.filter(
						(elem) => elem.name != "Ventas",
					);
				}
				this.consolidatedBusinessType =
					response.data["tipo_negocio_consolidado"];
			}
		},
		makeAccountPlansUnique() {
			makeUniquePlanAccounts(this.basic_data.companyId).then(() => {
				this.loadDefaultPlans();
			});
		},
		async downloadAllPlanAccounts() {
			// Carga la librería dinámicamente solo cuando se necesita
			const XLSX = await import('xlsx');
			let data = []
			this.account_plans.map((plan) => {
				data.push({
					"Nivel 1": plan.level_1,
					"Nivel 2": plan.level_2,
					"Nivel 3": plan.level_3,
				})
			});


			// Crear hoja y libro de trabajo
			const worksheet = XLSX.utils.json_to_sheet(data);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Plan de cuentas");

			// Generar y descargar el archivo
			XLSX.writeFile(workbook, "Plan de cuentas.xlsx");
		},
		uploadAllPlanAccounts() {
			this.$refs.fileInput.click();
		},
		uploadFilePlanAccounts(e) {
			const file = e.target.files[0];
			e.target.value = null;
			if (!file) return;

			const formData = new FormData();
			formData.append("planAccountsFile", file);

			upload_all_plan_accounts(this.basic_data.companyId, formData)
				.then(({ data }) => {
					if (data.result) {
						throw new Error(data.result)
					}
					this.loadDefaultPlans();
					notificate(
						`<strong>Subido con éxito</strong>
						<br>el archivo se subio correctamente`,
						"is-success is-light"
					);
				})
				.catch((err) => {
					notificate(
						`<strong>Error</strong>
						<br>hubo un problema con ${err}`,
						"is-danger is-light"
					);
				});
		},
		openConfirmRestoreModal(type, idPlanAccount) {
			let title = 'eliminar'
			let subTitle = 'Esta acción revertirá todos los cambios en prorratas y devengo'
			if (type == 'edit') {
				title = 'editar'
				subTitle = 'Esta acción cambiara la clasificación de todos los documentos asociados a esta cuenta'
			}
			this.$buefy.modal.open({
				...this.modalDefault,
				component: ConfirmRestore,
				props: {
					eventNameConfirmRestore: 'confirmEvent',
					tittleRestore: '¿Desea ' + title + ' esta cuenta?',
					subTittleRestore: subTitle,
					msgOkAction: title.charAt(0).toUpperCase() + title.slice(1)
				},
				events: {
					confirmEvent: () => {
						if (type == 'delete') {
							this.deletePlanAccount(idPlanAccount)
						} else if (type == 'edit') {
							this.editPlanAccount(idPlanAccount)
						}
					}
				},
			});
		},
	},
	watch: {
		basicData: {
			handler(data) {
				if (data && data.companyId) {
					this.basic_data = data;
					this.loadDefaultPlans();
					Object.keys(this.basic_data.business_types).map(item => {
						if (item == 'Servicios') {
							this.templateName = 'Plan de cuentas - Servicios'
						} else {
							this.templateName = 'Plan de cuentas - Productor'
						}
					})
				}
			},
			immediate: true,
		},
		indexEditing(newVal) {
			if (!!newVal && newVal >= 0) {
				this.level1Editing = this.account_plans[newVal].level_1;
				this.level3Editing = this.account_plans[newVal].level_3;
				this.orderEditing = this.account_plans[newVal].order;
				this.onLevel1Change(this.level1Editing);
				this.level2Editing = this.level_2_values_depending.find(
					(item) => item.level_2 == this.account_plans[newVal].level_2,
				).id;
			}
		},
	},
};
</script>
<style scoped lang="scss">
.account-plan {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
}

// ── Header ──────────────────────────────────────────────────────────────
.ap-header {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 44px;
	margin-bottom: 1.25rem;
}

.ap-title {
	font-size: 1.2rem;
	font-weight: 700;
	color: var(--ap-ink);
	text-align: center;
}

.ap-subtitle {
	text-align: center;
	font-weight: 600;
	color: var(--ap-slate);
	margin-bottom: 1.5rem;
}

.ap-actions {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&--left {
		left: 0;
	}

	&--right {
		right: 0;
	}
}

// ── Column headers ──────────────────────────────────────────────────────
.ap-colheads .column {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: var(--ap-muted);
}

// ── Rows ────────────────────────────────────────────────────────────────
.ap-row {
	padding: 0.5rem 0.75rem;
	margin-bottom: 0.25rem;
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	transition: border-color 0.2s var(--ap-ease), box-shadow 0.2s var(--ap-ease);

	&:hover {
		border-color: var(--ap-line-strong);
	}

	&--new {
		background-color: var(--ap-mist);
		border-style: dashed;
	}
}

// Franjas suaves por grupo de level_2 (clases devueltas por getRowBackground)
.bg-group-a {
	background-color: var(--ap-teal-wash);
}

.bg-group-b {
	background-color: var(--ap-paper);
}

.ap-cell {
	font-size: 1rem;
	color: var(--ap-ink-2);

	&--strong {
		font-weight: 600;
		color: var(--ap-ink);
	}

	&--num {
		font-weight: 600;
		font-variant-numeric: tabular-nums;
	}
}

.tag.is-primary {
	background-color: var(--ap-teal-wash);
	color: var(--ap-teal-deep);
	font-weight: 700;
	font-variant-numeric: tabular-nums;
}

// ── Operaciones (iconos) ────────────────────────────────────────────────
.ap-ops {
	display: flex;
	gap: 0.375rem;
}

.ap-icon-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 5px 8px;
	background: transparent;
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-slate);
	cursor: pointer;
	transition: color 0.18s var(--ap-ease), border-color 0.18s var(--ap-ease);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// ── Botones ─────────────────────────────────────────────────────────────
@mixin ap-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-family: var(--ap-font);
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	padding: 8px 16px;
	border: 1px solid transparent;
	border-radius: var(--ap-radius-pill);
	cursor: pointer;
	transition: background-color 0.18s var(--ap-ease), color 0.18s var(--ap-ease),
		border-color 0.18s var(--ap-ease), transform 0.18s var(--ap-ease);

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

.theme_btn_dark {
	@include ap-btn;
	background-color: var(--ap-ink);
	color: var(--ap-paper);

	&:hover {
		background-color: var(--ap-teal-deep);
		transform: translateY(-1px);
	}
}

.theme_btn_white {
	@include ap-btn;
	background-color: var(--ap-paper);
	color: var(--ap-ink);
	border-color: var(--ap-line-strong);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
		transform: translateY(-1px);
	}
}

.theme_btn_red {
	@include ap-btn;
	background-color: var(--ap-alert-wash);
	color: var(--ap-alert);
	border-color: var(--ap-alert);

	&:hover {
		background-color: var(--ap-alert);
		color: var(--ap-paper);
		transform: translateY(-1px);
	}
}

.theme_btn_blue {
	@include ap-btn;
	background-color: var(--ap-teal-wash);
	color: var(--ap-teal-deep);
	border-color: var(--ap-teal);

	&:hover {
		background-color: var(--ap-teal);
		color: var(--ap-paper);
		transform: translateY(-1px);
	}
}

.ap-inline-action {
	height: 100%;
}

.download_btn {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	max-width: fit-content;
	padding: 8px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	background: var(--ap-paper);
	color: var(--ap-ink-2);
	font-family: var(--ap-font);
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	text-decoration: none;
	transition: color 0.18s var(--ap-ease), border-color 0.18s var(--ap-ease);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// ── Inputs / selects ────────────────────────────────────────────────────
.new_elem_row {
	margin-left: 10px;
	margin-top: 5px;

	::v-deep .input,
	::v-deep .select select {
		border-radius: var(--ap-radius-sm);
		border-color: var(--ap-line-strong);
		font-family: var(--ap-font);
		transition: border-color 0.18s var(--ap-ease), box-shadow 0.18s var(--ap-ease);

		&:focus,
		&:focus-within {
			border-color: var(--ap-teal);
			box-shadow: 0 0 0 3px var(--ap-teal-wash);
		}
	}
}

#level_2_select {
	min-width: 100px;
}

.new_elem_row span select {
	font-weight: 600;
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

.td_level_2 {
	width: 14em;
}
</style>
